// eslint-disable-import/no-named-as-default

import classnames from 'classnames';
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import EnableForProjectState from '../../../features/security/EnableForProjectState';
import './AddProjectItemsNavMenu.scss';

const iconSize = 24;
const AddProjectItemsNavMenu = ({
  projectId,
  openPopover,
  isOpen,
  isNavScrollable,
}) => {
  const { t } = useTranslation();
  const ref = useRef();

  return (
    <div
      className="menu-wrapper"
      data-testid="add-project-items-nav-menu"
      ref={ref}
    >
      <EnableForProjectState projectId={projectId}>
        {({ isProjectDisabled }) => (
          <Button
            data-testid="fab"
            id="add-popover"
            className="button-avoid-focus menu-item hide-for-mobile add-icon"
            onClick={() =>
              !isProjectDisabled &&
              openPopover(
                ref?.current?.getBoundingClientRect()?.top || 0,
                !isOpen
              )
            }
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            disabled={isProjectDisabled}
          >
            <span className="menu-item-icon">
              <Icon
                name="add"
                className={classnames('fill', {
                  'icon-orange': !isProjectDisabled,
                  'icon-grey': isProjectDisabled,
                })}
                width={iconSize}
              />
            </span>
            <span className="menu-item-title">{t('addContentTitle')}</span>
            {!isNavScrollable && (
              <div className="menu-label">{t('addContentLabel')}</div>
            )}
          </Button>
        )}
      </EnableForProjectState>
      <div className="menu-separator" />
    </div>
  );
};

AddProjectItemsNavMenu.propTypes = {
  projectId: PropTypes.number.isRequired,
};

export default AddProjectItemsNavMenu;
